import { useState } from "react";
import { useAuth } from "../fetches/AuthorizationFetch";
import { mapToColumnField } from "../utils/mapColumnToField";

const useRecruitsUpdate = () => {
  const [updateError, setUpdateError] = useState(null);

  const { authenticatedFetch } = useAuth();

  const updateRecruit = async (recruitId, recruitData) => {
    if (!recruitId) {
      throw new Error("No recruit ID provided");
    }

    setUpdateError(null);
    const mappedRecruitData = mapToColumnField(recruitData);

    try {
      const response = await authenticatedFetch(
        `${process.env.REACT_APP_BASE_URL}/recruits/${recruitId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(mappedRecruitData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Failed to update recruit");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      setUpdateError(error.message);
      throw error;
    }
  };

  return { updateRecruit, updateError };
};

export default useRecruitsUpdate;
